import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseBillingSupplyAuthorizationsProps<T> = {
  filters?: {
    search?: string
    page?: number
    createdAtStartDate?: string
    createdAtEndDate?: string
    companyId?: string
    branchId?: string
    status?: string
  }
  mapper?: (data: any) => T
}

export const useBillingSupplyAuthorizations = <T,>({
  filters: { search = '', page = 1, createdAtStartDate, createdAtEndDate, companyId, branchId, status } = {},
  mapper = Mapper.default<T>(),
}: UseBillingSupplyAuthorizationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: [
      'billingSupplyAuthorizations',
      search,
      page,
      createdAtStartDate,
      createdAtEndDate,
      companyId,
      branchId,
      status,
    ],
    queryFn: () => {
      return privateAxios.get(`/billing/supply_authorizations`, {
        params: {
          search,
          page,
          'q[created_at_gteq]': createdAtStartDate,
          'q[created_at_lteq]': createdAtEndDate,
          'q[company_id_eq]': companyId,
          'q[branch_id_eq]': branchId,
          'q[status_eq]': status,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
